import i18n from "@/i18n.js";

export default [
  { id: "tracking_url", name: i18n.t("integrations.order-fulfillment-message.attribute.tracking_url") },
  { id: "tracking_code", name: i18n.t("integrations.order-fulfillment-message.attribute.tracking_code") },
  { id: "carrier", name: i18n.t("integrations.order-fulfillment-message.attribute.carrier") }
];
